import React from "react";
import PropTypes from "prop-types";
import { Provider } from "mobx-react";

import SubRequestStorage from "../../storages/SubRequestStorage";
import SubRequests from "./SubRequests";

const Container = ({
  currentUserHasScheduleManageAccess,
  locations,
  positions,
  currentUserPositions,
  page
}) => {
  const subRequestStorage = new SubRequestStorage(
    currentUserHasScheduleManageAccess,
    locations,
    positions,
    currentUserPositions,
    page
  );
  const storage = { subRequestStorage };

  return (
    <Provider {...storage}>
      <SubRequests />
    </Provider>
  );
};

Container.propTypes = {
  currentUserHasScheduleManageAccess: PropTypes.bool,
  locations: PropTypes.array,
  positions: PropTypes.array,
  currentUserPositions: PropTypes.array,
  page: PropTypes.string
};

export default Container;
